import styled from 'styled-components';

export const SelectWrapper = styled.div`
    position: relative;

    .elmo-spinner-container {
        position: absolute;
        padding: 0;
        top: 6px;
        right: 48px;
        z-index: 4;
    }
`;
